module.exports = __webpack_public_path__ + "img/cart.ffc2c5e5.svg";